// src/components/BackButton.jsx
"use client"

import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"

/**
 * BackButton
 * Props:
 * - to: ruta destino (default: "/menu")
 * - label: texto del botón (default: "Volver")
 * - variant: "dark" | "light" | "ghost" (default: "dark")
 * - className: estilos extra opcionales
 */
export default function BackButton({
  to = "/menu",
  label = "Volver",
  variant = "dark",
  className = "",
  ...props
}) {
  const navigate = useNavigate()

  const base = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    borderRadius: 999,
    padding: "8px 14px",
    cursor: "pointer",
    border: "1px solid transparent",
    transition: "background .15s ease, color .15s ease, border-color .15s ease",
  }

  const variants = {
    dark: {
      background: "#111827",
      color: "#fff",
      borderColor: "transparent",
      hoverBg: "#0b1220",
      hoverColor: "#fff",
      hoverBorder: "transparent",
    },
    light: {
      background: "#f3f4f6",
      color: "#111827",
      borderColor: "#e5e7eb",
      hoverBg: "#e5e7eb",
      hoverColor: "#111827",
      hoverBorder: "#d1d5db",
    },
    ghost: {
      background: "transparent",
      color: "#111827",
      borderColor: "#e5e7eb",
      hoverBg: "#f9fafb",
      hoverColor: "#111827",
      hoverBorder: "#d1d5db",
    },
  }

  const v = variants[variant] ?? variants.dark

  const style = {
    ...base,
    background: v.background,
    color: v.color,
    borderColor: v.borderColor,
  }

  const handleEnter = (e) => {
    e.currentTarget.style.background = v.hoverBg
    e.currentTarget.style.color = v.hoverColor
    e.currentTarget.style.borderColor = v.hoverBorder
  }

  const handleLeave = (e) => {
    e.currentTarget.style.background = v.background
    e.currentTarget.style.color = v.color
    e.currentTarget.style.borderColor = v.borderColor
  }

  return (
    <button
      type="button"
      aria-label={label}
      onClick={() => navigate(to)}
      style={style}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      className={className}
      {...props}
    >
      <ArrowLeft size={16} />
      {label}
    </button>
  )
}

/* Atajos prácticos */

// src/components/BackToMenu.jsx
export function BackToMenu(props) {
  return <BackButton to="/menu" label="Volver al menú" variant="dark" {...props} />
}

// src/components/BackToAdqMenu.jsx
export function BackToAdqMenu(props) {
  return (
    <BackButton
      to="/solicitud-adquisiciones"
      label="Volver al submenú"
      variant="light"
      {...props}
    />
  )
}
